<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Vendedor {{ form.nombre }}</h3>
      </div>
      <div class="layout__controls">
        <button v-show="(permiteEditarVendedor || permiteEliminarVendedor)" @click="$modal.show('vendedores')" class="btn-info btn--bigger"><i class="fa fa-search"></i> <span>Buscar</span></button>
        <modal name="vendedores" height="auto" width="60%" scrollable>
          <lista-vendedores @selected="selectedVendedor" :editButton="false" :createButton="false" :deleteButton="false"></lista-vendedores>
        </modal>
      </div>
    </div>
    <div class="layout__main">
      <div class="layout__main-form">
        <div class="card">
          <div class="card__title">
            <h5>Información del vendedor</h5>
          </div>
          <div class="card__content">
            <div class="row">
              <div class="col-xs-12 col-md-6">
                <div class="form-field">
                  <input-field v-model="form.codigo" id="codigo" placeholder="Escriba un código...">
                    Código
                    <span v-if="errores.codigo" class="helper-text text-danger" slot="helper">
                      {{ errores.codigo[0] }}
                    </span>
                  </input-field>
                </div>
                <div class="form-field">
                  <input-field v-model="form.nombre" id="nombre" placeholder="Escriba un nombre...">
                    Nombre
                    <span v-if="errores.nombre" class="helper-text text-danger" slot="helper">
                      {{ errores.nombre[0] }}
                    </span>
                  </input-field>
                </div>
              </div>
              <div class="col-xs-12 col-md-6">
                <input-field v-model="form.descripcion" id="nombre" placeholder="Escriba una descripción...">
                  Descripción
                  <span v-if="errores.descripcion" class="helper-text text-danger" slot="helper">
                    {{ errores.descripcion[0] }}
                  </span>
                </input-field>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="layout__main-buttons">
        <div class="card">
          <div class="card__content">
            <button v-show="(permiteCrearVendedor && estado === 'N') || (permiteEditarVendedor && estado !== 'N')" @click="guardar" class="btn-success" type="button"><i class="fa fa-save"></i> <span>Guardar</span></button>
            <button v-show="permiteCrearVendedor" @click="crearNueva" class="btn-secondary btn--text" type="button"><i class="fa fa-plus"></i><span>Nuevo</span></button>
            <button v-show="estado === 'A' && permiteEliminarVendedor" @click="eliminar" type="button" class="btn-danger btn--text"><i class="fa fa-ban"></i> <span>Eliminar</span></button>
            <button v-show="estado === 'I' && permiteEliminarVendedor" @click="eliminar" type="button" class="btn-success btn--text"><i class="fa fa-power-off"></i> <span>Re-activar</span></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    props : {
        permiteCrearVendedor : {
            type : Boolean,
            default : true,
            required : true
        },
        permiteEditarVendedor : {
            type : Boolean,
            default : true,
            required : true
        },
        permiteEliminarVendedor : {
            type : Boolean,
            default : true,
            required : true
        }
    },
    data : function () {
        return {
            form : {
                nombre : '',
                descripcion : '',
                _method : undefined,
                codigo : ''
            },
            estado : 'N',
            errores : {
                nombre : undefined,
                descripcion : undefined,
                codigo : undefined
            },
            id : '',
            url : url
        };
    },
    methods : {
        crearNueva : function () {
            let that = this;
            swal({
                title: '¿Desea crear un nuevo vendedor?',
                text: "El formulario será reiniciado.",
                type: 'warning',
                showCancelButton: true,
                confirmButtonText : 'Crear nuevo',
                cancelButtonText : 'Cancelar'
                }).then((result) => {
                    if (result.value)
                    {
                        that.limpiarFormulario();
                        that.limpiarErrores();
                        that.estado = 'N';
                    }
            });
        },
        limpiarFormulario : function () {
            this.form = {
                nombre : '',
                descripcion : '',
                _method : undefined,
                codigo : ''
            };
        },
        limpiarErrores : function () {
            this.errores = {
                nombre : undefined,
                descripcion : undefined,
                codigo : undefined
            };
        },
        guardar : function () {
            this.limpiarErrores();
            let that = this;
            let urlRequest = url + '/vendedores';
            if (this.estado !== 'N')
            {
                this.form._method = 'PUT';
                urlRequest += '/' + this.id;
            }
            else 
                this.form._method = undefined;
            axios.post(urlRequest, this.form).then(function (response) {
                that.estado = response.data.estado;
                that.id = response.data.id;
                swal('El vendedor fue almacenado exitósamente.', 'Realizado', 'success');
            }).catch(function (error) {
                if (error !== null && error !== undefined) {
                    let response = error.response;
                    if (response !== null && response !== undefined) {
                        let status = response.status;
                        if (status === 422) {
                            that.errores = response.data.errors;
                            swal('Hay errores en el formulario.', 'Aviso', 'warning');
                        }
                        else 
                            swal('Hubo un error al momento de guardar el formulario, intente nuevamente.', 'Error', 'error');
                    }
                }
            });
        },
        eliminar : function () {
            let that = this;
            swal({
                title: '¿Desea ' + (this.estado === 'A'?'eliminar':'re-activar') + ' esta categoría?',
                text: "El vendededor será " + (this.estado === 'A'?'eliminado':'re-activado') + ".",
                type: 'warning',
                showCancelButton: true,
                confirmButtonText : (this.estado === 'A'?'Eliminar':'Re-activar'),
                cancelButtonText : 'Cancelar'
                }).then((result) => {
                    if (result.value)
                    {
                        axios.post(that.url + '/vendedores/' + that.id, {
                            _method : 'DELETE'
                        }).then(function (response) {
                            that.estado = response.data.estado;
                            swal('El vendedor ha sido ' + (that.estado === 'I'?'eliminado':'re-activado') + '.', 'Realizado', 'success');
                        });
                    }
            });
        },
        selectedVendedor : function (vendedor) {
            this.form.nombre = vendedor.nombre;
            this.form.descripcion = vendedor.descripcion;
            this.form.codigo = vendedor.codigo;
            this.estado = vendedor.estado;
            this.id = vendedor.id;
            this.$modal.hide('vendedores');
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/mantenimiento/vendedores/Vendedor.vue